import React, { FC } from 'react';
import { ASSETS_BASE_URL } from '../../../lib/constants';

type CommentsIconProps = {
  className?: string;
  commentsCount?: number;
};

const CommentsIcon: FC<CommentsIconProps> = ({ className, commentsCount }) => {
  return (
    <div className="flex items-center ml-2">
      <img className="h-6" src={`${ASSETS_BASE_URL}system/cw-assets/chat-not-filled.svg`} alt="votes icon" />
      <div className={`text-sm ml-1`}>{commentsCount ?? 0}</div>
    </div>
  );
};

export default CommentsIcon;
